/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoAnalyticsModelsAvailabilityStatusListItem,
    MelcoAnalyticsModelsAvailabilityStatusListItemFromJSON,
    MelcoAnalyticsModelsAvailabilityStatusListItemFromJSONTyped,
    MelcoAnalyticsModelsAvailabilityStatusListItemToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem
 */
export interface MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem {
    /**
     * 
     * @type {Array<MelcoAnalyticsModelsAvailabilityStatusListItem>}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem
     */
    list: Array<MelcoAnalyticsModelsAvailabilityStatusListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemFromJSON(json: any): MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem {
    return MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoAnalyticsModelsAvailabilityStatusListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemToJSON(value?: MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoAnalyticsModelsAvailabilityStatusListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


